import React, { useEffect, useState } from 'react';
import gearSpin from "../../assets/img/gear-loader.gif"
import axios from 'axios';
import { LOGIN } from '../../redux/constants';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

function OnboardingSlide9() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const userData = useSelector((state) => state.auth);

    const [is_complete, setis_complete] = useState(false);

    useEffect(() => {
        const callApis = async () => {
            try {
                await Promise.all([
                    axios.post(`${process.env.REACT_APP_API_URL}/onboarding/import_iso_codes`),
                    axios.post(`${process.env.REACT_APP_API_URL}/onboarding/import_tracking_todos`).then(res => {
                        setis_complete(true)
                    }).catch(error => {
                        setis_complete(true)
                    }),
                ])
            } catch (error) {
                setis_complete(true);
            }
        }

        callApis();

    },[]);

    useEffect(() => {
        if(is_complete){
            let authUser = { ...userData };
            authUser.is_subscribed = true;
            authUser.is_board_complete = true;
            dispatch({ type: LOGIN, payload: authUser });
            localStorage.setItem("user", JSON.stringify(authUser));
            navigate("/", { replace: true });
        }
    }, [is_complete])

  return (
    <div className="space-y-4 xl:space-y-6 xl:pt-6 pt-5 h-full flex flex-col justify-center items-center"
        style={{ maxHeight: "calc(100% - 42px)" }}
    >
        <img src={gearSpin} alt='Gear Spinner' className='bg-white' />
        <p className='text-2xl font-inter font-semibold text-center text-[#1E293B] '>Prepare Your Dashboard...</p>
    </div>
  )
}

export default OnboardingSlide9;